import React, {useState} from "react";
import SDRadio from "./sdRadio";
import './sdRadioGroup.scss';

function SDRadioGroup (props) {
  const [nowSelect, setNowSelect] = useState(props.value ?? -1);
  function selectRadio (e) {
    setNowSelect(e);

    if (props.onSelect) {
      props.onSelect(e);
    }
  }

  return (
    <div className="mainRadioGroup">
      <div className="label">{props.label}</div>
      <div className="radioGroupBody">
      {props.data.map((d, i) => {
        return <SDRadio group={true} label={d} value={(nowSelect == i)}
        index={i} key={d} changeSelect={e => selectRadio(e)}></SDRadio>
      })}
      </div>
    </div>
  )
}

export default SDRadioGroup;